module.exports = __webpack_public_path__ + "static/media/wildify-desktop.fa6dd92c.jpg";